<kendo-pdf-export #report paperSize="A4" margin="false" forcePageBreak=".ap-report-page-break" class="ap-report">
  <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
    <!-- Header -->
    <div class="ap-report-header">
      <div>{{'Global__CustomerNumber' | translate}}: {{currentFarm.CustomerNumber}}</div>
      <div>{{'Global__Farm' | translate}}: {{currentFarm.FarmName}}</div>
    </div>
    <!-- Footer-->
    <div class="ap-report-footer">
      <div class="ap-report-footer-note">{{'AgriConnect_Hint_User_Derivation' | translate}}</div>
      <img alt="Agriport" src="../../../../assets/svg/agriport-logo.svg" class="ap-report-footer-icon">
      <div class="ap-report-footer-page">{{pageNum}} / {{totalPages}}</div>
      <div class="ap-report-footer-date">{{currentDateTime}}</div>
    </div>
  </ng-template>
  <div class="ap-report-basedata-grid">
    <!--Basedata-->
    <div class="ap-report-basedata">
      <div class="ap-report-basedata-label">{{'Nutrients_Ips_Pages__PlanningType' | translate}}</div>
      <div class="ap-report-basedata-content ap-report-border-bottom">{{getModuleName() | translate}}</div>
      <div class="ap-report-basedata-label">{{'Global__Task' | translate}}</div>
      <div class="ap-report-basedata-content ap-report-border-bottom">{{reportName}} ({{'Global__No_Short' | translate}} {{planSummary?.SourceItem?.PlanNumber}})</div>
      <div class="ap-report-basedata-label">{{'Nutrients_Pages_Popups__Distribution' | translate}}</div>
      <div class="ap-report-basedata-content ap-report-bold ap-report-preformatted">{{planSummary?.ProductName}}{{getProductNutrientExpr()}}</div>
      <div class="ap-report-basedata-content ap-report-border-bottom">{{isPpModule() ? '' : planSummary?.ApplicationModeText}}</div>
      <div class="ap-report-basedata-label">{{'Nutrients_DistributionAmount' | translate}}</div>
      <div class="ap-report-basedata-content ap-report-border-bottom ap-report-bold ap-report-preformatted">{{getApplSumForAllFields() | getRoundNumeric:0}}
        {{planSummary?.ProductUnit}} {{(isPpModule() ? 'Global__Water' : '') | translate}} {{getPpProductSumExpr()}}</div>
      <div class="ap-report-basedata-label">{{'AgriConnect__Count_Fields' | translate}} ({{'AgriConnect__TotalArea' | translate}})</div>
      <div class="ap-report-basedata-content ap-report-border-bottom">{{getFieldsCount()}} ({{getFieldsArea() | getRoundNumeric:2 }} {{'Base__UnitHa' | translate}})</div>
      <div class="ap-report-basedata-label">{{'Global__Worker' | translate}}</div>
      <div class="ap-report-basedata-content ap-report-border-bottom">{{getExportDriverName()}}</div>
      <div class="ap-report-basedata-label">{{'Base__Engine' | translate}} / {{'Docu_Ini__Tool' | translate}}</div>
      <div class="ap-report-basedata-content">{{getExportMachineInstrument()}}</div>
    </div>

    <!--Element-->
    <div class="ap-report-element">
      <div class="ap-report-element-sign ap-report-border-bottom ap-report-bold">{{getElementExpression()}}</div>
      <div class="ap-report-element-appl">{{planSummary?.ApplicationModeText}}</div>
    </div>

    <!--Comment-->
    <div class="ap-report-comment">
      <div class="ap-report-comment-header ap-report-border-bottom">{{'Global__Comment' | translate}}:</div>
      <div class="ap-report-comment-text"></div>
    </div>
  </div>

  <!--Fields-->
  <div class="ap-report-fields-grid" *ngFor="let itemsChunk of itemsChunked; let i = index" [ngClass]="i > 0 ? 'ap-report-page-break':''">
    <!--General header for product-->
    <div class="ap-report-fields-heading ap-report-border-bottom"></div>
    <!--column headers-->
    <div class="ap-report-fields-header-pos">{{'AgriConnect_Position_Short' | translate}}</div>
    <div class="ap-report-fields-header-field">{{'Global__Field' | translate}}</div>
    <div class="ap-report-fields-header-area">{{'Global__Area' | translate}}</div>
    <div class="ap-report-fields-header-map">{{'AgriConnect_Map' | translate}}</div>
    <div class="ap-report-fields-header-amount">{{getProductHeader()}}</div>
    <div class="ap-report-fields-header-statistic">{{'Nutrients__StatisticsTitle' | translate}} <div *ngIf="!isNFertilization()">({{getProductHeader()}})</div></div>
    <!--field content-->
    <ng-container *ngFor="let item of itemsChunk">
      <div class="ap-report-fields-content-pos">{{item?.SourceItem?.Position}}</div>
      <div class="ap-report-fields-content-field">
        <div>
          <div>{{getFieldName(item)}}</div>
          <div>{{getCropName(item)}}</div>
        </div>
        <div>{{'Task_Mgmt_Report_Applied_at' | translate}}:<br>
        {{'Global__Sum_Goods' | translate}}:</div>
      </div>
      <div class="ap-report-fields-content-area">
        <div>
          <div class="ap-report-bold">{{item?.SourceItem.AreaHa  | getRoundNumeric:2}}</div>
          <div>{{'Base__UnitHa' | translate}}<br></div>
        </div>
      </div>
      <div class="ap-report-fields-content-map">
        <!-- Render maps of max 2 pages in advance to avoid 'insufficient resources error' when generating huge pdf files with lots of planBooks-->
        <ap-layer-export *ngIf="(renderedMaps + (itemsChunk.length * 2)) >= (itemsChunk.length * i)" [featureId]="item?.SourceItem.Id" [sourceLayer]="taskManagementLayer" [olStyle]="exportMapStyle" [mapUrl]="getMapUrl(item)" (renderCompleted)="onRenderCompleted()" class="ap-reports-map"></ap-layer-export>
      </div>
      <div class="ap-report-fields-content-amount ap-report-align-right">
        <div>
          <div class="ap-report-bold">{{item?.ApplSum | getRoundNumeric:0}}</div>
          <div>{{planSummary?.ProductUnit}}</div>
        </div>
      </div>
      <div class="ap-report-fields-content-statistic">
        <div>
          <div *ngIf="isApplModeVariable()">
            <div class="ap-report-statistic-layout">
              <div>{{'MinShort' | translate}}:</div>
              <div>{{item?.ApplMin | getRoundNumeric:0}} {{item?.ProductUnitPerHa}}</div>
            </div>
            <div class="ap-report-statistic-layout">
              <div>Ø:</div>
              <div>{{item?.ApplRate | getRoundNumeric:0}} {{item?.ProductUnitPerHa}}</div>
            </div>
            <div class="ap-report-statistic-layout">
              <div>{{'MaxShort' | translate}}:</div>
              <div>{{item?.ApplMax | getRoundNumeric:0}} {{item?.ProductUnitPerHa}}</div>
            </div>
            <div class="ap-report-statistic-layout" *ngIf="item?.SourceItem?.ECValue !== null">
              <div>{{'Global__EC' | translate}}:</div>
              <div>{{item?.SourceItem?.ECValue | getRoundNumeric:0}}</div>
            </div>
          </div>
          <div *ngIf="!isApplModeVariable()">
            <div class="ap-report-statistic-layout">
              <div>{{'Nutrients_DistributionConst' | translate}}:</div>
              <div>{{this.getApplRate(item) | getRoundNumeric:0}} {{item?.ProductUnitPerHa}}</div>
            </div>
            <div class="ap-report-statistic-layout" *ngIf="isNFertilization()">
              <div>{{'Global__EC' | translate}}:</div>
              <div>{{item?.SourceItem?.ECValue}}</div>
            </div>
          </div>
        </div>
        <div class="ap-report-font-small" *ngIf="isApplModeVariable()"><!--* {{'Task_Mgmt_Report_Modified_by_user' | translate}}--></div>
      </div>
    </ng-container>
  </div>
</kendo-pdf-export>
